/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as IndexRouteImport } from './routes/index';
import { Route as DesignRouteImport } from './routes/design';
import { Route as LoginRouteImport } from './routes/login';
import { Route as AccountSecurityRouteImport } from './routes/account/security';
import { Route as AppointmentTypesIndexRouteImport } from './routes/appointment-types/index';
import { Route as AppointmentsIndexRouteImport } from './routes/appointments/index';
import { Route as AppointmentsAppointmentIdRouteImport } from './routes/appointments/$appointmentId';
import { Route as FeedbackIndexRouteImport } from './routes/feedback/index';
import { Route as FormsIndexRouteImport } from './routes/forms/index';
import { Route as IntegrationsIndexRouteImport } from './routes/integrations/index';
import { Route as IntegrationsKeyRouteImport } from './routes/integrations/$key';
import { Route as LogsIndexRouteImport } from './routes/logs/index';
import { Route as MfaEnrollRouteImport } from './routes/mfa/enroll';
import { Route as NotificationsIndexRouteImport } from './routes/notifications/index';
import { Route as NotificationsRemindersRouteImport } from './routes/notifications/reminders';
import { Route as NotificationsTemplatesRouteImport } from './routes/notifications/templates';
import { Route as PatientsIndexRouteImport } from './routes/patients/index';
import { Route as PatientsPatientIdRouteImport } from './routes/patients/$patientId';
import { Route as PricingIndexRouteImport } from './routes/pricing/index';
import { Route as PricingEligibilityRouteImport } from './routes/pricing/eligibility';
import { Route as ProvidersIndexRouteImport } from './routes/providers/index';
import { Route as ProvidersProviderIdRouteImport } from './routes/providers/$providerId';
import { Route as ReportsIndexRouteImport } from './routes/reports/index';
import { Route as ReportsCommunicationsRouteImport } from './routes/reports/communications';
import { Route as ReportsFunnelRouteImport } from './routes/reports/funnel';
import { Route as ReportsInsurancePaymentsRouteImport } from './routes/reports/insurance-payments';
import { Route as ReportsIntegrationsRouteImport } from './routes/reports/integrations';
import { Route as ReviewIndexRouteImport } from './routes/review/index';
import { Route as SchedulingIndexRouteImport } from './routes/scheduling/index';
import { Route as SettingsIndexRouteImport } from './routes/settings/index';
import { Route as SettingsDomainsRouteImport } from './routes/settings/domains';
import { Route as UsersIndexRouteImport } from './routes/users/index';
import { Route as FormsFormIdIndexRouteImport } from './routes/forms/$formId/index';
import { Route as FormsFormIdVersionsRouteImport } from './routes/forms/$formId/versions';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const DesignRoute = DesignRouteImport.update({
  id: '/design',
  path: '/design',
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const AccountSecurityRoute = AccountSecurityRouteImport.update({
  id: '/account/security',
  path: '/account/security',
  getParentRoute: () => rootRouteImport,
} as any);
const AppointmentTypesIndexRoute = AppointmentTypesIndexRouteImport.update({
  id: '/appointment-types/',
  path: '/appointment-types/',
  getParentRoute: () => rootRouteImport,
} as any);
const AppointmentsIndexRoute = AppointmentsIndexRouteImport.update({
  id: '/appointments/',
  path: '/appointments/',
  getParentRoute: () => rootRouteImport,
} as any);
const AppointmentsAppointmentIdRoute =
  AppointmentsAppointmentIdRouteImport.update({
    id: '/appointments/$appointmentId',
    path: '/appointments/$appointmentId',
    getParentRoute: () => rootRouteImport,
  } as any);
const FeedbackIndexRoute = FeedbackIndexRouteImport.update({
  id: '/feedback/',
  path: '/feedback/',
  getParentRoute: () => rootRouteImport,
} as any);
const FormsIndexRoute = FormsIndexRouteImport.update({
  id: '/forms/',
  path: '/forms/',
  getParentRoute: () => rootRouteImport,
} as any);
const IntegrationsIndexRoute = IntegrationsIndexRouteImport.update({
  id: '/integrations/',
  path: '/integrations/',
  getParentRoute: () => rootRouteImport,
} as any);
const IntegrationsKeyRoute = IntegrationsKeyRouteImport.update({
  id: '/integrations/$key',
  path: '/integrations/$key',
  getParentRoute: () => rootRouteImport,
} as any);
const LogsIndexRoute = LogsIndexRouteImport.update({
  id: '/logs/',
  path: '/logs/',
  getParentRoute: () => rootRouteImport,
} as any);
const MfaEnrollRoute = MfaEnrollRouteImport.update({
  id: '/mfa/enroll',
  path: '/mfa/enroll',
  getParentRoute: () => rootRouteImport,
} as any);
const NotificationsIndexRoute = NotificationsIndexRouteImport.update({
  id: '/notifications/',
  path: '/notifications/',
  getParentRoute: () => rootRouteImport,
} as any);
const NotificationsRemindersRoute = NotificationsRemindersRouteImport.update({
  id: '/notifications/reminders',
  path: '/notifications/reminders',
  getParentRoute: () => rootRouteImport,
} as any);
const NotificationsTemplatesRoute = NotificationsTemplatesRouteImport.update({
  id: '/notifications/templates',
  path: '/notifications/templates',
  getParentRoute: () => rootRouteImport,
} as any);
const PatientsIndexRoute = PatientsIndexRouteImport.update({
  id: '/patients/',
  path: '/patients/',
  getParentRoute: () => rootRouteImport,
} as any);
const PatientsPatientIdRoute = PatientsPatientIdRouteImport.update({
  id: '/patients/$patientId',
  path: '/patients/$patientId',
  getParentRoute: () => rootRouteImport,
} as any);
const PricingIndexRoute = PricingIndexRouteImport.update({
  id: '/pricing/',
  path: '/pricing/',
  getParentRoute: () => rootRouteImport,
} as any);
const PricingEligibilityRoute = PricingEligibilityRouteImport.update({
  id: '/pricing/eligibility',
  path: '/pricing/eligibility',
  getParentRoute: () => rootRouteImport,
} as any);
const ProvidersIndexRoute = ProvidersIndexRouteImport.update({
  id: '/providers/',
  path: '/providers/',
  getParentRoute: () => rootRouteImport,
} as any);
const ProvidersProviderIdRoute = ProvidersProviderIdRouteImport.update({
  id: '/providers/$providerId',
  path: '/providers/$providerId',
  getParentRoute: () => rootRouteImport,
} as any);
const ReportsIndexRoute = ReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => rootRouteImport,
} as any);
const ReportsCommunicationsRoute = ReportsCommunicationsRouteImport.update({
  id: '/reports/communications',
  path: '/reports/communications',
  getParentRoute: () => rootRouteImport,
} as any);
const ReportsFunnelRoute = ReportsFunnelRouteImport.update({
  id: '/reports/funnel',
  path: '/reports/funnel',
  getParentRoute: () => rootRouteImport,
} as any);
const ReportsInsurancePaymentsRoute =
  ReportsInsurancePaymentsRouteImport.update({
    id: '/reports/insurance-payments',
    path: '/reports/insurance-payments',
    getParentRoute: () => rootRouteImport,
  } as any);
const ReportsIntegrationsRoute = ReportsIntegrationsRouteImport.update({
  id: '/reports/integrations',
  path: '/reports/integrations',
  getParentRoute: () => rootRouteImport,
} as any);
const ReviewIndexRoute = ReviewIndexRouteImport.update({
  id: '/review/',
  path: '/review/',
  getParentRoute: () => rootRouteImport,
} as any);
const SchedulingIndexRoute = SchedulingIndexRouteImport.update({
  id: '/scheduling/',
  path: '/scheduling/',
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsDomainsRoute = SettingsDomainsRouteImport.update({
  id: '/settings/domains',
  path: '/settings/domains',
  getParentRoute: () => rootRouteImport,
} as any);
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => rootRouteImport,
} as any);
const FormsFormIdIndexRoute = FormsFormIdIndexRouteImport.update({
  id: '/forms/$formId/',
  path: '/forms/$formId/',
  getParentRoute: () => rootRouteImport,
} as any);
const FormsFormIdVersionsRoute = FormsFormIdVersionsRouteImport.update({
  id: '/forms/$formId/versions',
  path: '/forms/$formId/versions',
  getParentRoute: () => rootRouteImport,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/design': typeof DesignRoute;
  '/login': typeof LoginRoute;
  '/account/security': typeof AccountSecurityRoute;
  '/appointments/$appointmentId': typeof AppointmentsAppointmentIdRoute;
  '/integrations/$key': typeof IntegrationsKeyRoute;
  '/mfa/enroll': typeof MfaEnrollRoute;
  '/notifications/reminders': typeof NotificationsRemindersRoute;
  '/notifications/templates': typeof NotificationsTemplatesRoute;
  '/patients/$patientId': typeof PatientsPatientIdRoute;
  '/pricing/eligibility': typeof PricingEligibilityRoute;
  '/providers/$providerId': typeof ProvidersProviderIdRoute;
  '/reports/communications': typeof ReportsCommunicationsRoute;
  '/reports/funnel': typeof ReportsFunnelRoute;
  '/reports/insurance-payments': typeof ReportsInsurancePaymentsRoute;
  '/reports/integrations': typeof ReportsIntegrationsRoute;
  '/settings/domains': typeof SettingsDomainsRoute;
  '/appointment-types/': typeof AppointmentTypesIndexRoute;
  '/appointments/': typeof AppointmentsIndexRoute;
  '/feedback/': typeof FeedbackIndexRoute;
  '/forms/': typeof FormsIndexRoute;
  '/integrations/': typeof IntegrationsIndexRoute;
  '/logs/': typeof LogsIndexRoute;
  '/notifications/': typeof NotificationsIndexRoute;
  '/patients/': typeof PatientsIndexRoute;
  '/pricing/': typeof PricingIndexRoute;
  '/providers/': typeof ProvidersIndexRoute;
  '/reports/': typeof ReportsIndexRoute;
  '/review/': typeof ReviewIndexRoute;
  '/scheduling/': typeof SchedulingIndexRoute;
  '/settings/': typeof SettingsIndexRoute;
  '/users/': typeof UsersIndexRoute;
  '/forms/$formId/versions': typeof FormsFormIdVersionsRoute;
  '/forms/$formId/': typeof FormsFormIdIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/design': typeof DesignRoute;
  '/login': typeof LoginRoute;
  '/account/security': typeof AccountSecurityRoute;
  '/appointments/$appointmentId': typeof AppointmentsAppointmentIdRoute;
  '/integrations/$key': typeof IntegrationsKeyRoute;
  '/mfa/enroll': typeof MfaEnrollRoute;
  '/notifications/reminders': typeof NotificationsRemindersRoute;
  '/notifications/templates': typeof NotificationsTemplatesRoute;
  '/patients/$patientId': typeof PatientsPatientIdRoute;
  '/pricing/eligibility': typeof PricingEligibilityRoute;
  '/providers/$providerId': typeof ProvidersProviderIdRoute;
  '/reports/communications': typeof ReportsCommunicationsRoute;
  '/reports/funnel': typeof ReportsFunnelRoute;
  '/reports/insurance-payments': typeof ReportsInsurancePaymentsRoute;
  '/reports/integrations': typeof ReportsIntegrationsRoute;
  '/settings/domains': typeof SettingsDomainsRoute;
  '/appointment-types': typeof AppointmentTypesIndexRoute;
  '/appointments': typeof AppointmentsIndexRoute;
  '/feedback': typeof FeedbackIndexRoute;
  '/forms': typeof FormsIndexRoute;
  '/integrations': typeof IntegrationsIndexRoute;
  '/logs': typeof LogsIndexRoute;
  '/notifications': typeof NotificationsIndexRoute;
  '/patients': typeof PatientsIndexRoute;
  '/pricing': typeof PricingIndexRoute;
  '/providers': typeof ProvidersIndexRoute;
  '/reports': typeof ReportsIndexRoute;
  '/review': typeof ReviewIndexRoute;
  '/scheduling': typeof SchedulingIndexRoute;
  '/settings': typeof SettingsIndexRoute;
  '/users': typeof UsersIndexRoute;
  '/forms/$formId/versions': typeof FormsFormIdVersionsRoute;
  '/forms/$formId': typeof FormsFormIdIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/design': typeof DesignRoute;
  '/login': typeof LoginRoute;
  '/account/security': typeof AccountSecurityRoute;
  '/appointments/$appointmentId': typeof AppointmentsAppointmentIdRoute;
  '/integrations/$key': typeof IntegrationsKeyRoute;
  '/mfa/enroll': typeof MfaEnrollRoute;
  '/notifications/reminders': typeof NotificationsRemindersRoute;
  '/notifications/templates': typeof NotificationsTemplatesRoute;
  '/patients/$patientId': typeof PatientsPatientIdRoute;
  '/pricing/eligibility': typeof PricingEligibilityRoute;
  '/providers/$providerId': typeof ProvidersProviderIdRoute;
  '/reports/communications': typeof ReportsCommunicationsRoute;
  '/reports/funnel': typeof ReportsFunnelRoute;
  '/reports/insurance-payments': typeof ReportsInsurancePaymentsRoute;
  '/reports/integrations': typeof ReportsIntegrationsRoute;
  '/settings/domains': typeof SettingsDomainsRoute;
  '/appointment-types/': typeof AppointmentTypesIndexRoute;
  '/appointments/': typeof AppointmentsIndexRoute;
  '/feedback/': typeof FeedbackIndexRoute;
  '/forms/': typeof FormsIndexRoute;
  '/integrations/': typeof IntegrationsIndexRoute;
  '/logs/': typeof LogsIndexRoute;
  '/notifications/': typeof NotificationsIndexRoute;
  '/patients/': typeof PatientsIndexRoute;
  '/pricing/': typeof PricingIndexRoute;
  '/providers/': typeof ProvidersIndexRoute;
  '/reports/': typeof ReportsIndexRoute;
  '/review/': typeof ReviewIndexRoute;
  '/scheduling/': typeof SchedulingIndexRoute;
  '/settings/': typeof SettingsIndexRoute;
  '/users/': typeof UsersIndexRoute;
  '/forms/$formId/versions': typeof FormsFormIdVersionsRoute;
  '/forms/$formId/': typeof FormsFormIdIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/design'
    | '/login'
    | '/account/security'
    | '/appointments/$appointmentId'
    | '/integrations/$key'
    | '/mfa/enroll'
    | '/notifications/reminders'
    | '/notifications/templates'
    | '/patients/$patientId'
    | '/pricing/eligibility'
    | '/providers/$providerId'
    | '/reports/communications'
    | '/reports/funnel'
    | '/reports/insurance-payments'
    | '/reports/integrations'
    | '/settings/domains'
    | '/appointment-types/'
    | '/appointments/'
    | '/feedback/'
    | '/forms/'
    | '/integrations/'
    | '/logs/'
    | '/notifications/'
    | '/patients/'
    | '/pricing/'
    | '/providers/'
    | '/reports/'
    | '/review/'
    | '/scheduling/'
    | '/settings/'
    | '/users/'
    | '/forms/$formId/versions'
    | '/forms/$formId/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/design'
    | '/login'
    | '/account/security'
    | '/appointments/$appointmentId'
    | '/integrations/$key'
    | '/mfa/enroll'
    | '/notifications/reminders'
    | '/notifications/templates'
    | '/patients/$patientId'
    | '/pricing/eligibility'
    | '/providers/$providerId'
    | '/reports/communications'
    | '/reports/funnel'
    | '/reports/insurance-payments'
    | '/reports/integrations'
    | '/settings/domains'
    | '/appointment-types'
    | '/appointments'
    | '/feedback'
    | '/forms'
    | '/integrations'
    | '/logs'
    | '/notifications'
    | '/patients'
    | '/pricing'
    | '/providers'
    | '/reports'
    | '/review'
    | '/scheduling'
    | '/settings'
    | '/users'
    | '/forms/$formId/versions'
    | '/forms/$formId';
  id:
    | '__root__'
    | '/'
    | '/design'
    | '/login'
    | '/account/security'
    | '/appointments/$appointmentId'
    | '/integrations/$key'
    | '/mfa/enroll'
    | '/notifications/reminders'
    | '/notifications/templates'
    | '/patients/$patientId'
    | '/pricing/eligibility'
    | '/providers/$providerId'
    | '/reports/communications'
    | '/reports/funnel'
    | '/reports/insurance-payments'
    | '/reports/integrations'
    | '/settings/domains'
    | '/appointment-types/'
    | '/appointments/'
    | '/feedback/'
    | '/forms/'
    | '/integrations/'
    | '/logs/'
    | '/notifications/'
    | '/patients/'
    | '/pricing/'
    | '/providers/'
    | '/reports/'
    | '/review/'
    | '/scheduling/'
    | '/settings/'
    | '/users/'
    | '/forms/$formId/versions'
    | '/forms/$formId/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  DesignRoute: typeof DesignRoute;
  LoginRoute: typeof LoginRoute;
  AccountSecurityRoute: typeof AccountSecurityRoute;
  AppointmentsAppointmentIdRoute: typeof AppointmentsAppointmentIdRoute;
  IntegrationsKeyRoute: typeof IntegrationsKeyRoute;
  MfaEnrollRoute: typeof MfaEnrollRoute;
  NotificationsRemindersRoute: typeof NotificationsRemindersRoute;
  NotificationsTemplatesRoute: typeof NotificationsTemplatesRoute;
  PatientsPatientIdRoute: typeof PatientsPatientIdRoute;
  PricingEligibilityRoute: typeof PricingEligibilityRoute;
  ProvidersProviderIdRoute: typeof ProvidersProviderIdRoute;
  ReportsCommunicationsRoute: typeof ReportsCommunicationsRoute;
  ReportsFunnelRoute: typeof ReportsFunnelRoute;
  ReportsInsurancePaymentsRoute: typeof ReportsInsurancePaymentsRoute;
  ReportsIntegrationsRoute: typeof ReportsIntegrationsRoute;
  SettingsDomainsRoute: typeof SettingsDomainsRoute;
  AppointmentTypesIndexRoute: typeof AppointmentTypesIndexRoute;
  AppointmentsIndexRoute: typeof AppointmentsIndexRoute;
  FeedbackIndexRoute: typeof FeedbackIndexRoute;
  FormsIndexRoute: typeof FormsIndexRoute;
  IntegrationsIndexRoute: typeof IntegrationsIndexRoute;
  LogsIndexRoute: typeof LogsIndexRoute;
  NotificationsIndexRoute: typeof NotificationsIndexRoute;
  PatientsIndexRoute: typeof PatientsIndexRoute;
  PricingIndexRoute: typeof PricingIndexRoute;
  ProvidersIndexRoute: typeof ProvidersIndexRoute;
  ReportsIndexRoute: typeof ReportsIndexRoute;
  ReviewIndexRoute: typeof ReviewIndexRoute;
  SchedulingIndexRoute: typeof SchedulingIndexRoute;
  SettingsIndexRoute: typeof SettingsIndexRoute;
  UsersIndexRoute: typeof UsersIndexRoute;
  FormsFormIdVersionsRoute: typeof FormsFormIdVersionsRoute;
  FormsFormIdIndexRoute: typeof FormsFormIdIndexRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/design': {
      id: '/design';
      path: '/design';
      fullPath: '/design';
      preLoaderRoute: typeof DesignRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/account/security': {
      id: '/account/security';
      path: '/account/security';
      fullPath: '/account/security';
      preLoaderRoute: typeof AccountSecurityRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/appointment-types/': {
      id: '/appointment-types/';
      path: '/appointment-types';
      fullPath: '/appointment-types/';
      preLoaderRoute: typeof AppointmentTypesIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/appointments/': {
      id: '/appointments/';
      path: '/appointments';
      fullPath: '/appointments/';
      preLoaderRoute: typeof AppointmentsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/appointments/$appointmentId': {
      id: '/appointments/$appointmentId';
      path: '/appointments/$appointmentId';
      fullPath: '/appointments/$appointmentId';
      preLoaderRoute: typeof AppointmentsAppointmentIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/feedback/': {
      id: '/feedback/';
      path: '/feedback';
      fullPath: '/feedback/';
      preLoaderRoute: typeof FeedbackIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/forms/': {
      id: '/forms/';
      path: '/forms';
      fullPath: '/forms/';
      preLoaderRoute: typeof FormsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/integrations/': {
      id: '/integrations/';
      path: '/integrations';
      fullPath: '/integrations/';
      preLoaderRoute: typeof IntegrationsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/integrations/$key': {
      id: '/integrations/$key';
      path: '/integrations/$key';
      fullPath: '/integrations/$key';
      preLoaderRoute: typeof IntegrationsKeyRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/logs/': {
      id: '/logs/';
      path: '/logs';
      fullPath: '/logs/';
      preLoaderRoute: typeof LogsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/mfa/enroll': {
      id: '/mfa/enroll';
      path: '/mfa/enroll';
      fullPath: '/mfa/enroll';
      preLoaderRoute: typeof MfaEnrollRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/notifications/': {
      id: '/notifications/';
      path: '/notifications';
      fullPath: '/notifications/';
      preLoaderRoute: typeof NotificationsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/notifications/reminders': {
      id: '/notifications/reminders';
      path: '/notifications/reminders';
      fullPath: '/notifications/reminders';
      preLoaderRoute: typeof NotificationsRemindersRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/notifications/templates': {
      id: '/notifications/templates';
      path: '/notifications/templates';
      fullPath: '/notifications/templates';
      preLoaderRoute: typeof NotificationsTemplatesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/patients/': {
      id: '/patients/';
      path: '/patients';
      fullPath: '/patients/';
      preLoaderRoute: typeof PatientsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/patients/$patientId': {
      id: '/patients/$patientId';
      path: '/patients/$patientId';
      fullPath: '/patients/$patientId';
      preLoaderRoute: typeof PatientsPatientIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/pricing/': {
      id: '/pricing/';
      path: '/pricing';
      fullPath: '/pricing/';
      preLoaderRoute: typeof PricingIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/pricing/eligibility': {
      id: '/pricing/eligibility';
      path: '/pricing/eligibility';
      fullPath: '/pricing/eligibility';
      preLoaderRoute: typeof PricingEligibilityRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/providers/': {
      id: '/providers/';
      path: '/providers';
      fullPath: '/providers/';
      preLoaderRoute: typeof ProvidersIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/providers/$providerId': {
      id: '/providers/$providerId';
      path: '/providers/$providerId';
      fullPath: '/providers/$providerId';
      preLoaderRoute: typeof ProvidersProviderIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/reports/': {
      id: '/reports/';
      path: '/reports';
      fullPath: '/reports/';
      preLoaderRoute: typeof ReportsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/reports/communications': {
      id: '/reports/communications';
      path: '/reports/communications';
      fullPath: '/reports/communications';
      preLoaderRoute: typeof ReportsCommunicationsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/reports/funnel': {
      id: '/reports/funnel';
      path: '/reports/funnel';
      fullPath: '/reports/funnel';
      preLoaderRoute: typeof ReportsFunnelRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/reports/insurance-payments': {
      id: '/reports/insurance-payments';
      path: '/reports/insurance-payments';
      fullPath: '/reports/insurance-payments';
      preLoaderRoute: typeof ReportsInsurancePaymentsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/reports/integrations': {
      id: '/reports/integrations';
      path: '/reports/integrations';
      fullPath: '/reports/integrations';
      preLoaderRoute: typeof ReportsIntegrationsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/review/': {
      id: '/review/';
      path: '/review';
      fullPath: '/review/';
      preLoaderRoute: typeof ReviewIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/scheduling/': {
      id: '/scheduling/';
      path: '/scheduling';
      fullPath: '/scheduling/';
      preLoaderRoute: typeof SchedulingIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/settings/': {
      id: '/settings/';
      path: '/settings';
      fullPath: '/settings/';
      preLoaderRoute: typeof SettingsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/settings/domains': {
      id: '/settings/domains';
      path: '/settings/domains';
      fullPath: '/settings/domains';
      preLoaderRoute: typeof SettingsDomainsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/users/': {
      id: '/users/';
      path: '/users';
      fullPath: '/users/';
      preLoaderRoute: typeof UsersIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/forms/$formId/': {
      id: '/forms/$formId/';
      path: '/forms/$formId';
      fullPath: '/forms/$formId/';
      preLoaderRoute: typeof FormsFormIdIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/forms/$formId/versions': {
      id: '/forms/$formId/versions';
      path: '/forms/$formId/versions';
      fullPath: '/forms/$formId/versions';
      preLoaderRoute: typeof FormsFormIdVersionsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DesignRoute: DesignRoute,
  LoginRoute: LoginRoute,
  AccountSecurityRoute: AccountSecurityRoute,
  AppointmentsAppointmentIdRoute: AppointmentsAppointmentIdRoute,
  IntegrationsKeyRoute: IntegrationsKeyRoute,
  MfaEnrollRoute: MfaEnrollRoute,
  NotificationsRemindersRoute: NotificationsRemindersRoute,
  NotificationsTemplatesRoute: NotificationsTemplatesRoute,
  PatientsPatientIdRoute: PatientsPatientIdRoute,
  PricingEligibilityRoute: PricingEligibilityRoute,
  ProvidersProviderIdRoute: ProvidersProviderIdRoute,
  ReportsCommunicationsRoute: ReportsCommunicationsRoute,
  ReportsFunnelRoute: ReportsFunnelRoute,
  ReportsInsurancePaymentsRoute: ReportsInsurancePaymentsRoute,
  ReportsIntegrationsRoute: ReportsIntegrationsRoute,
  SettingsDomainsRoute: SettingsDomainsRoute,
  AppointmentTypesIndexRoute: AppointmentTypesIndexRoute,
  AppointmentsIndexRoute: AppointmentsIndexRoute,
  FeedbackIndexRoute: FeedbackIndexRoute,
  FormsIndexRoute: FormsIndexRoute,
  IntegrationsIndexRoute: IntegrationsIndexRoute,
  LogsIndexRoute: LogsIndexRoute,
  NotificationsIndexRoute: NotificationsIndexRoute,
  PatientsIndexRoute: PatientsIndexRoute,
  PricingIndexRoute: PricingIndexRoute,
  ProvidersIndexRoute: ProvidersIndexRoute,
  ReportsIndexRoute: ReportsIndexRoute,
  ReviewIndexRoute: ReviewIndexRoute,
  SchedulingIndexRoute: SchedulingIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  UsersIndexRoute: UsersIndexRoute,
  FormsFormIdVersionsRoute: FormsFormIdVersionsRoute,
  FormsFormIdIndexRoute: FormsFormIdIndexRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
